import { IRange } from './constants'
import { createRange } from './range'

interface IDiffResult extends IRange {
  text: string
}

export const diff = (aStr: string, bStr: string, cursor?: number): IDiffResult | null => {
  if (aStr === bStr) {
    return null
  }

  if (typeof cursor !== 'undefined') {
    const textAfterCursorLength = bStr.length - cursor
    if (textAfterCursorLength > 0) {
      const aAfterCursor = aStr.slice(-textAfterCursorLength)
      const bAfterCursor = bStr.slice(-textAfterCursorLength)
      if (aAfterCursor === bAfterCursor) {
        aStr = aStr.slice(0, -textAfterCursorLength)
        bStr = bStr.slice(0, -textAfterCursorLength)
      }
    }
  }

  const a = aStr.split('')
  const b = bStr.split('')

  const diffStart = shiftEquals(a, b)
  a.reverse()
  b.reverse()
  const diffEnd = shiftEquals(a, b)
  const diffLength = aStr.length - diffStart - diffEnd
  const text = b.reverse().join('')
  return { ...createRange(diffStart, diffLength), text }
}

function shiftEquals(a: string[], b: string[]): number {
  let count = 0
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      break
    }
    count++
  }
  a.splice(0, count)
  b.splice(0, count)
  return count
}
